module.exports = __webpack_public_path__ + "img/player-details-bg.1caa396e.png";